import angular from 'angular';

export const textEditorAttackOptions = () => {
    return {
        $get: () => (gettextCatalog, qrOptions, callsBack, ctrl) => {
            let langCode = 'ru';
            if (window.appCtrl && window.appCtrl.langCode && window.appCtrl.langCode != 'ru') {
                langCode = window.appCtrl.langCode;
            }
            return {
                height: 500,
                language: langCode,
                invalid_elements: 'iframe',
                plugins: 'code preview phishImage qr_code lists paste codemirror fullpage',
                toolbar1: 'undo redo | paste | styleselect | bold italic | alignleft aligncenter alignright | bullist numlist outdent indent | code | preview',
                toolbar2: `firstNameTemplate secondNameTemplate ${window.appCtrl.langCode !== 'ru' ? '' : 'thirdNameTemplate'} | dateTemplate | phishImage detectImage fishLink qr_code ${callsBack() !== 'noAttachment' ? '| attachLink ' : ''} | tags`,
                theme_advanced_buttons3_add : 'fullpage',
                fullpage_fontsizes : '13px,14px,15px,18pt,xx-large',
                fullpage_default_xml_pi : false,
                fullpage_default_langcode : 'en',
                fullpage_default_title : 'My document title',
                menubar: false,
                visual: false,
                qr_code: {
                    ...qrOptions
                },
                relative_urls: true,
                remove_script_host: false,
                paste_data_images: true,
                theme: 'silver',
                content_style: '.mce-content-body {font-family:Verdana,Arial,Helvetica,sans-serif;font-size:11px;white-space: break-spaces;}.mce-content-body div.mce-resizehandle{background-color:#4099ff;border-color:#4099ff;border-style:solid;border-width:1px;box-sizing:border-box;height:10px;position:absolute;width:10px;z-index:10000}.mce-content-body div.mce-resizehandle:hover{background-color:#4099ff}.mce-content-body div.mce-resizehandle:nth-of-type(1){cursor:nwse-resize}.mce-content-body div.mce-resizehandle:nth-of-type(2){cursor:nesw-resize}.mce-content-body div.mce-resizehandle:nth-of-type(3){cursor:nwse-resize}.mce-content-body div.mce-resizehandle:nth-of-type(4){cursor:nesw-resize}.mce-content-body .mce-clonedresizable{opacity:.5;outline:1px dashed #000;position:absolute;z-index:10000}.mce-content-body .mce-resize-helper{background:#555;background:rgba(0,0,0,.75);border:1px;border-radius:3px;color:#fff;display:none;font-family:sans-serif;font-size:12px;line-height:14px;margin:5px 10px;padding:5px;position:absolute;white-space:nowrap;z-index:10001}',
                images_dataimg_filter: function (img) {
                    return img.hasAttribute('internal-blob');
                },
                selector: 'textarea',
                ui_container: '.modal-dialog',
                content_css: false,
                skin: false,
                codemirror: {
                    indentOnInit: true, // Whether or not to indent code on init.
                    fullscreen: false,   // Default setting is false
                    path: 'CodeMirror', // Path to CodeMirror distribution
                    config: {           // CodeMirror config object
                        lineNumbers: true
                    },
                    width: 800,         // Default value is 800
                    height: 600,        // Default value is 550
                    saveCursorPosition: false    // Insert caret marker
                },
                force_br_newlines : false,
                force_p_newlines : false,
                forced_root_block : '',
                setup: function (editor) {
                    editor.on('blur', () => {
                        ctrl.checkText(true);
                    });
                    editor.ui.registry.addButton('dateTemplate', {
                        icon: 'insert-time',
                        tooltip:gettextCatalog.getString('Дата'),
                        onAction: function () {
                            editor.insertContent('{dmy}');
                        }
                    });
                    editor.ui.registry.addButton('firstNameTemplate', {
                        text: gettextCatalog.getString('Фамилия'),
                        tooltip: gettextCatalog.getString('Фамилия'),
                        onAction: function () {
                            editor.insertContent('{last_name}');
                        }
                    });
                    editor.ui.registry.addButton('secondNameTemplate', {
                        text: gettextCatalog.getString('Имя'),
                        tooltip: gettextCatalog.getString('Имя'),
                        onAction: function () {
                            editor.insertContent('{name}');
                        }
                    });
                    if (langCode === 'ru') {
                        editor.ui.registry.addButton('thirdNameTemplate', {
                            text: gettextCatalog.getString('Отчество'),
                            tooltip: gettextCatalog.getString('Отчество'),
                            onAction: function () {
                                editor.insertContent('{middle_name}');
                            }
                        });
                    }
                    editor.ui.registry.addIcon('image-detect',
                        '<svg class="svg-gray" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n' + '    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n' +
                        '        <path d="M5,15.7393398 L8.26966991,12.4696699 C8.56256313,12.1767767 9.03743687,12.1767767 9.33033009,12.4696699 L11.9,15.0393398 L16.0030032,10.9363366 C16.2958965,10.6434434 16.7707702,10.6434434 17.0636634,10.9363366 L19,12.8726732 L19,5 L5,5 L5,15.7393398 Z M5,17.8606602 L5,19 L7.93933983,19 L10.8393398,16.1 L8.8,14.0606602 L5,17.8606602 Z M19,14.9939935 L16.5333333,12.5273268 L10.0606602,19 L19,19 L19,14.9939935 Z M4,3 L20,3 C20.5522847,3 21,3.44771525 21,4 L21,20 C21,20.5522847 20.5522847,21 20,21 L4,21 C3.44771525,21 3,20.5522847 3,20 L3,4 C3,3.44771525 3.44771525,3 4,3 Z M10,11 C11.1045695,11 12,10.1045695 12,9 C12,7.8954305 11.1045695,7 10,7 C8.8954305,7 8,7.8954305 8,9 C8,10.1045695 8.8954305,11 10,11 Z" fill="#000000" fill-rule="nonzero"></path>\n' +
                        '    </g>\n' + '</svg>');

                    function insertDetectImage () {
                        editor.selection.select(editor.getBody(), true);
                        editor.selection.collapse(false);
                        editor.insertContent('<img id="_image_" style="display:none;" class="image" src="{protocol}{templateCode}.{domain}/payload/openMail/?token={payload}">');
                    }

                    function toggleAttachment(add) {
                        if (add) {
                            editor.insertContent('<a class="_attachment_" href="{protocol}{templateCode}.{domain}/payload/downloadAttache/{payload}?file=true&isFromLink=true" title="{attachment_file_link}">' +
                                '{attachment_file_link}' + '</a>');
                        } else {
                            const array = editor.dom.$('._attachment_');
                            editor.dom.remove(array);
                        }
                    }

                    editor.ui.registry.addToggleButton('detectImage', {
                        icon: 'image-detect',
                        tooltip: gettextCatalog.getString('Изображение-детектор'),
                        onAction: (buttonApi) => {
                            if (buttonApi.isActive()) {
                                editor.dom.remove('_image_');
                            } else {
                                insertDetectImage();
                            }
                            buttonApi.setActive(editor.getContent().indexOf('_image_') > -1);
                        },
                        onSetup: (buttonApi) => {
                            setTimeout(() => {
                                if (!editor.getContent()) {
                                    insertDetectImage();
                                }
                                buttonApi.setActive(editor.getContent().indexOf('_image_') > -1);
                            }, 1000);
                            editor.on('change', function () {
                                if (!editor.getContent()) {
                                    insertDetectImage();
                                }
                                buttonApi.setActive(editor.getContent().indexOf('_image_') > -1);
                            });
                        }
                    });
                    editor.ui.registry.addIcon('link-detect',
                        '<svg class="svg-red" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n' + '    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n' +
                        '        <g transform="translate(3.000000, 3.000000)" fill="#000000" fill-rule="nonzero">\n' +
                        '            <path d="M3.19,9.345 C3.56860324,8.96738132 4.18139676,8.96738132 4.56,9.345 C4.7414263,9.52619538 4.84336998,9.7720877 4.84336998,10.0285 C4.84336998,10.2849123 4.7414263,10.5308046 4.56,10.712 L2.505,12.764 C2.14184108,13.1264311 1.93775923,13.6184301 1.93775923,14.1315 C1.93775923,14.6445699 2.14184108,15.1365689 2.505,15.499 C3.26220647,16.2542374 4.48779353,16.2542374 5.245,15.499 L10.039,10.712 C10.2204263,10.5308046 10.32237,10.2849123 10.32237,10.0285 C10.32237,9.7720877 10.2204263,9.52619538 10.039,9.345 C9.85726729,9.16376439 9.75512902,8.9176576 9.75512902,8.661 C9.75512902,8.4043424 9.85726729,8.15823561 10.039,7.977 C10.4176032,7.59938132 11.0303968,7.59938132 11.409,7.977 C11.9538916,8.5206667 12.2601117,9.25877256 12.2601117,10.0285 C12.2601117,10.7982274 11.9538916,11.5363333 11.409,12.08 L6.614,16.867 C5.09981452,18.3780248 2.64818548,18.3780248 1.134,16.867 C0.407682162,16.1421379 -0.000481544301,15.1581397 -0.000481544301,14.132 C-0.000481544301,13.1058603 0.407682162,12.1218621 1.134,11.397 L3.19,9.344 L3.19,9.345 Z M14.81,8.655 C14.4313968,9.03261868 13.8186032,9.03261868 13.44,8.655 C13.2585737,8.47380462 13.15663,8.2279123 13.15663,7.9715 C13.15663,7.7150877 13.2585737,7.46919538 13.44,7.288 L15.495,5.236 C15.8581589,4.87356893 16.0622408,4.38156986 16.0622408,3.8685 C16.0622408,3.35543014 15.8581589,2.86343107 15.495,2.501 C14.7377935,1.74576265 13.5122065,1.74576265 12.755,2.501 L7.962,7.288 C7.7805737,7.46919538 7.67863002,7.7150877 7.67863002,7.9715 C7.67863002,8.2279123 7.7805737,8.47380462 7.962,8.655 C8.14373271,8.83623561 8.24587098,9.0823424 8.24587098,9.339 C8.24587098,9.5956576 8.14373271,9.84176439 7.962,10.023 C7.58339676,10.4006187 6.97060324,10.4006187 6.592,10.023 C6.0471084,9.4793333 5.74088831,8.74122744 5.74088831,7.9715 C5.74088831,7.20177256 6.0471084,6.4636667 6.592,5.92 L11.387,1.133 C12.9011855,-0.378024781 15.3528145,-0.378024781 16.867,1.133 C17.5933178,1.85786214 18.0014815,2.84186028 18.0014815,3.868 C18.0014815,4.89413972 17.5933178,5.87813786 16.867,6.603 L14.81,8.656 L14.81,8.655 Z"></path>\n' +
                        '        </g>\n' + '    </g>\n' + '</svg>');
                    editor.ui.registry.addIcon('link-attachment',
                        '<svg id="link-attachment-button" width="9px" height="18px" viewBox="0 0 9 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n' + '    <g id="Main" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n' +
                        '        <g id="Elements" transform="translate(-1466.000000, -4240.000000)" fill="#D95350" fill-rule="nonzero">\n' +
                        '            <path d="M1473.62879,4244.01515 L1473.62879,4253.25 C1473.62879,4255.0247 1472.19136,4256.46212 1470.41667,4256.46212 C1468.64197,4256.46212 1467.20455,4255.0247 1467.20455,4253.25 L1467.20455,4243.21212 C1467.20455,4242.10394 1468.10394,4241.20455 1469.21212,4241.20455 C1470.3203,4241.20455 1471.2197,4242.10394 1471.2197,4243.21212 L1471.2197,4251.64394 C1471.2197,4252.08561 1470.86235,4252.44697 1470.41667,4252.44697 C1469.97098,4252.44697 1469.61364,4252.08561 1469.61364,4251.64394 L1469.61364,4244.01515 L1468.40909,4244.01515 L1468.40909,4251.64394 C1468.40909,4252.75212 1469.30848,4253.65152 1470.41667,4253.65152 C1471.52485,4253.65152 1472.42424,4252.75212 1472.42424,4251.64394 L1472.42424,4243.21212 C1472.42424,4241.43742 1470.98682,4240 1469.21212,4240 C1467.43742,4240 1466,4241.43742 1466,4243.21212 L1466,4253.25 C1466,4255.69121 1467.97947,4257.66667 1470.41667,4257.66667 C1472.85386,4257.66667 1474.83333,4255.69121 1474.83333,4253.25 L1474.83333,4244.01515 L1473.62879,4244.01515 Z" id="Shape"></path>\n' +
                        '        </g>\n' + '    </g>\n' + '</svg>');
                    editor.ui.registry.addButton('fishLink', {
                        icon: 'link-detect',
                        tooltip: gettextCatalog.getString('Фишинговая ссылка'),
                        onAction: function () {
                            editor.insertContent('<a href="{protocol}{templateCode}.{domain}/payload/openLink/?token={payload}" title="' + (gettextCatalog.getString('Текст ссылки')) + '">' +
                                (gettextCatalog.getString('Текст ссылки')) + '</a>');
                        }
                    });
                    editor.ui.registry.addToggleButton('attachLink', {
                        icon: 'link-attachment',
                        tooltip: gettextCatalog.getString('Ссылка на файл'),
                        onAction: (buttonApi) => {
                            let active = !buttonApi.isActive();
                            toggleAttachment(active);
                            buttonApi.setActive(~editor.getContent().indexOf('_attachment_'));
                            callsBack(active, editor.getContent());
                        },
                        onSetup: (buttonApi) => {
                            setTimeout(() => {
                                let active = !!~editor.getContent().indexOf('_attachment_');
                                buttonApi.setActive(active);
                                callsBack(active, editor.getContent());
                                let button = document.querySelector('#link-attachment-button');
                                let buttonWrapper = button?.parentNode?.parentNode?.parentNode;
                                buttonWrapper.style.display = 'none';
                            }, 100);
                            editor.on('change', function () {
                                if (buttonApi.isActive() && !~editor.getContent().indexOf('_attachment_')) {
                                    buttonApi.setActive(false);
                                    callsBack(false, editor.getContent());
                                }
                            });
                        }
                    });
                    editor.ui.registry.addMenuButton('tags', {
                        text: gettextCatalog.getString('Переменные'),
                        fetch: (callback) => {
                            let tagList = [
                                {
                                    type: 'nestedmenuitem',
                                    text: gettextCatalog.getString('Общие'),
                                    getSubmenuItems: () => {
                                        return [
                                            {
                                                type: 'menuitem',
                                                text: (gettextCatalog.getString('Дата')) + ' d.m.Y',
                                                onAction: function () {
                                                    editor.insertContent('{dmy}');
                                                }
                                            },
                                            {
                                                type: 'menuitem',
                                                text: (gettextCatalog.getString('Дата d.m.Y [+/-]N дней')),
                                                onAction: function () {
                                                    editor.insertContent('{dmy+N}');
                                                }
                                            },
                                            {
                                                type: 'menuitem',
                                                text: gettextCatalog.getString('Дата с форматированием'),
                                                onAction: function () {
                                                    editor.insertContent('{date}');
                                                }
                                            },
                                            {
                                                type: 'menuitem',
                                                text: gettextCatalog.getString('Дата с форматированием [+/-]N дней'),
                                                onAction: function () {
                                                    editor.insertContent('{date+N}');
                                                }
                                            },
                                            {
                                                type: 'menuitem',
                                                text: gettextCatalog.getString('День'),
                                                onAction: function () {
                                                    editor.insertContent('{day}');
                                                }
                                            },
                                            {
                                                type: 'menuitem',
                                                text: gettextCatalog.getString('Месяц'),
                                                onAction: function () {
                                                    editor.insertContent('{month}');
                                                }
                                            },
                                            {
                                                type: 'menuitem',
                                                text: gettextCatalog.getString('Год'),
                                                onAction: function () {
                                                    editor.insertContent('{year}');
                                                }
                                            },
                                            {
                                                type: 'menuitem',
                                                text: gettextCatalog.getString('Случайное число из N цифр'),
                                                onAction: function () {
                                                    editor.insertContent('{rand:N}');
                                                }
                                            }
                                        ];
                                    }
                                },
                                {
                                    type: 'nestedmenuitem',
                                    text: gettextCatalog.getString('Администратор'),
                                    getSubmenuItems: () => {
                                        return [
                                            {
                                                type: 'menuitem',
                                                text: gettextCatalog.getString('Фамилия'),
                                                onAction: function () {
                                                    editor.insertContent('{admin_last_name}');
                                                }
                                            },
                                            {
                                                type: 'menuitem',
                                                text: gettextCatalog.getString('Имя'),
                                                onAction: function () {
                                                    editor.insertContent('{admin_name}');
                                                }
                                            },
                                            {
                                                type: window.appCtrl.langCode === 'ru' && 'menuitem',
                                                text: window.appCtrl && window.appCtrl.langCode === 'ru' ? gettextCatalog.getString('Отчество') : '',
                                                onAction: window.appCtrl.langCode === 'ru' && function () {
                                                    editor.insertContent('{admin_middle_name}');
                                                }
                                            },
                                            {
                                                type: 'menuitem',
                                                text: gettextCatalog.getString('Электронная почта'),
                                                onAction: function () {
                                                    editor.insertContent('{admin_email}');
                                                }
                                            },
                                            {
                                                type: 'menuitem',
                                                text: gettextCatalog.getString('Номер телефона'),
                                                onAction: function () {
                                                    editor.insertContent('{admin_phone}');
                                                }
                                            },
                                            {
                                                type: 'menuitem',
                                                text: gettextCatalog.getString('Компания'),
                                                onAction: function () {
                                                    editor.insertContent('{admin_company}');
                                                }
                                            },
                                            {
                                                type: 'menuitem',
                                                text: gettextCatalog.getString('Отдел'),
                                                onAction: function () {
                                                    editor.insertContent('{admin_department}');
                                                }
                                            },
                                            {
                                                type: 'menuitem',
                                                text: gettextCatalog.getString('Должность'),
                                                onAction: function () {
                                                    editor.insertContent('{admin_position}');
                                                }
                                            }
                                        ];
                                    }
                                },
                                {
                                    type: 'nestedmenuitem',
                                    text: gettextCatalog.getString('Сотрудник'),
                                    getSubmenuItems: () => {
                                        return [
                                            {
                                                type: 'menuitem',
                                                text: gettextCatalog.getString('Фамилия'),
                                                onAction: function () {
                                                    editor.insertContent('{last_name}');
                                                }
                                            },
                                            {
                                                type: 'menuitem',
                                                text: gettextCatalog.getString('Имя'),
                                                onAction: function () {
                                                    editor.insertContent('{name}');
                                                }
                                            },
                                            {
                                                type: window.appCtrl.langCode === 'ru' && 'menuitem',
                                                text: window.appCtrl && window.appCtrl.langCode === 'ru' ? gettextCatalog.getString('Отчество') : '',
                                                onAction: window.appCtrl.langCode === 'ru' && function () {
                                                    editor.insertContent('{middle_name}');
                                                }
                                            },
                                            {
                                                type: 'menuitem',
                                                text: gettextCatalog.getString('Электронная почта'),
                                                onAction: function () {
                                                    editor.insertContent('{email}');
                                                }
                                            },
                                            {
                                                type: 'menuitem',
                                                text: gettextCatalog.getString('Отдел'),
                                                onAction: function () {
                                                    editor.insertContent('{department}');
                                                }
                                            },
                                            {
                                                type: 'menuitem',
                                                text: gettextCatalog.getString('Должность'),
                                                onAction: function () {
                                                    editor.insertContent('{position}');
                                                }
                                            }
                                        ];
                                    }
                                },
                                {
                                    type: 'nestedmenuitem',
                                    text: gettextCatalog.getString('Атака'),
                                    getSubmenuItems: () => {
                                        return [
                                            {
                                                type: 'menuitem',
                                                text: gettextCatalog.getString('Код шаблона'),
                                                onAction: function () {
                                                    editor.insertContent('{template_code}');
                                                }
                                            },
                                            {
                                                type: 'menuitem',
                                                text: gettextCatalog.getString('Домен'),
                                                onAction: function () {
                                                    editor.insertContent('{domain}');
                                                }
                                            },
                                            {
                                                type: 'menuitem',
                                                text: gettextCatalog.getString('Уникальный код письма'),
                                                onAction: function () {
                                                    editor.insertContent('{payload}');
                                                }
                                            },
                                            {
                                                type: 'menuitem',
                                                text: gettextCatalog.getString('Пароль'),
                                                onAction: function () {
                                                    editor.insertContent('{password}');
                                                }
                                            }
                                        ];
                                    }
                                }
                            ];
                            let tagsByGroup = {};
                            let otherTags = [];
                            if (window.mceTags && window.mceTags.length) {
                                tagList.push({
                                    text: '|'
                                });
                                angular.forEach(window.mceTags, (tag) => {
                                    if (tag.group) {
                                        if (!tagsByGroup[tag.group]) {
                                            tagsByGroup[tag.group] = [];
                                        }
                                        tagsByGroup[tag.group].push({
                                            type: 'menuitem',
                                            text: tag.name,
                                            onAction: function () {
                                                editor.insertContent(tag.tag);
                                            }
                                        });
                                    } else {
                                        otherTags.push({
                                            type: 'menuitem',
                                            text: tag.name,
                                            onAction: function () {
                                                editor.insertContent(tag.tag);
                                            }
                                        });
                                    }
                                });
                            }
                            angular.forEach(tagsByGroup, (tags, groupName) => {
                                tagList.push({
                                    type: 'nestedmenuitem',
                                    text: groupName,
                                    getSubmenuItems: () => {
                                        return tags;
                                    }
                                });
                            });
                            angular.forEach(otherTags, (tag) => {
                                tagList.push(tag);
                            });
                            callback(tagList);
                        }
                    });
                }
            };
        }
    };
};
